import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=46a5e7dc&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=js&"
export * from "./storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5e7dc",
  null
  
)

export default component.exports